<template>
    <v-dialog
        v-model="loading"
        fullscreen
        full-width
        transition="fade-transition"
    >
      <v-container fluid fill-height style="background-color: rgba(0, 0, 0, .2);">
        <v-layout column justify-center align-center>
            <v-progress-circular
                indeterminate
                size="300"
                width="30"
                color="primary"
                class="my-2"
            ></v-progress-circular>
            <h1 class="text-xs-center white--text my-2 display-1 font-weight-light">
                {{ message }}
            </h1>
        </v-layout>
      </v-container>
    </v-dialog>
</template>

<script>

export default {
    props: {
        loading: {
            type: Boolean,
            default: true
        },
        message: {
            type: String,
            default: "Loading. Please wait..."
        }
    }
}

</script>
